export enum PlayheadContextDispatchActionType {
	updateLastSwitchTime,
	updateCalculatedData,
}
